import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";

import { TimeStamp } from "../TimeStamp";
import { Author } from "../Author";
import { useStateValue } from "../../SharedContext";
import { getTextColor } from "../../../utils/utils";
import { ReadTime } from "../ReadTime";

import "./author-with-timestamp.m.css";

export const AuthorWithTime = ({
  story,
  hideAuthorImage,
  prefix,
  isLightTheme,
  showMultipleAuthor,
  showTimeStamp = true,
  showReadTime = true,
  showAuthorContent = true,
}) => {
  const configState = useStateValue() || {};
  const isReadTime = !showReadTime ? showReadTime : get(configState, ["showReadTime"], true);
  const textColor = isLightTheme ? "light" : getTextColor(configState.theme);

  const getTimeStamp = () => {
    return (
      <>
        {showAuthorContent && (
          <span className="arr-separator" styleName={`dash ${textColor}`}>
            |
          </span>
        )}
        <TimeStamp story={story} />
        {isReadTime && <ReadTime story={story} isLightTheme={isLightTheme} />}
      </>
    );
  };

  return (
    <div className="arr--author-time" styleName="author-time-wrapper">
      <>
        {showAuthorContent && (
          <Author
            story={story}
            isBottom
            hideAuthorImage={hideAuthorImage}
            prefix={prefix}
            showMultipleAuthor={showMultipleAuthor}
          />
        )}
        {showTimeStamp && getTimeStamp()}
      </>
    </div>
  );
};

AuthorWithTime.propTypes = {
  story: PropTypes.object,
  /** hide the author image */
  hideAuthorImage: PropTypes.bool,
  // fix prefix before the author name
  prefix: PropTypes.string,
  config: PropTypes.object,
  isLightTheme: PropTypes.bool,
  showMultipleAuthor: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
};

AuthorWithTime.defaultProps = {
  hideAuthorImage: true,
  prefix: "",
  isLightTheme: false,
  showMultipleAuthor: true,
  showTimeStamp: true,
};
